<template>
  <div>
    <div class="d-flex justify-space-between mb-2">
      <v-skeleton-loader
        class="checkout-page-text-field"
        color="transparent"
        type="text"
        width="25%"
      ></v-skeleton-loader>
      <v-skeleton-loader
        class="checkout-page-text-field"
        color="transparent"
        type="text"
        width="20%"
      ></v-skeleton-loader>
    </div>
    <div class="d-flex justify-space-between mb-2">
      <v-skeleton-loader
        class="checkout-page-text-field"
        color="transparent"
        type="text"
        width="15%"
      ></v-skeleton-loader>
      <v-skeleton-loader
        class="checkout-page-text-field"
        color="transparent"
        type="text"
        width="20%"
      ></v-skeleton-loader>
    </div>
    <div
      v-for="index in subSkeleton"
      :key="index"
      class="d-flex justify-space-between mb-3"
    >
      <v-skeleton-loader
        class="checkout-page-text-field"
        color="transparent"
        type="text"
        width="25%"
      ></v-skeleton-loader>
      <v-skeleton-loader
        class="checkout-page-text-field"
        color="transparent"
        type="text"
        width="20%"
      ></v-skeleton-loader>
    </div>

    <v-divider class="my-4"></v-divider>

    <div class="d-flex justify-space-between">
      <v-skeleton-loader
        class="checkout-page-text-field"
        color="transparent"
        type="text"
        width="25%"
        height="30"
      ></v-skeleton-loader>
      <v-skeleton-loader
        class="checkout-page-text-field"
        color="transparent"
        type="text"
        width="20%"
        height="30"
      ></v-skeleton-loader>
    </div>
  </div>
</template>

<script>
export default {
  name: "CartTotalSkeleton",
  props: {
    subSkeleton: {
      type: Number,
      default: 2,
    },
  },
};
</script>
